import z from "zod";

export enum MediaType {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
};

export const MediaSchema = z.object({
    type: z.nativeEnum(MediaType),
    objectKey: z.string().min(1),
});
export type MediaDTO = z.infer<typeof MediaSchema>;
